import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        background: '#fff',
        primary: '#ff5500',
        secondary: '#b0bec5',
        accent: '#8c9eff',
        error: '#b71c1c',
        textGray: '#696969',
        textBlack: '#111',
        bgGray: '#EBEBEB',
        gray: '#666',
        lightGray: '#f5f5f5',
        lightGray1: '#C5C3C3',
        lightGray2: '#FAFAFA',
        lighterGray: '#ccc',
        lightOrange: '#FFEFE7',
      },
    },
  },
})
